import { onDestroy, onMount } from 'svelte';
import { get } from 'svelte/store';

export function alphasort(key = 'name') {
  return (a, b) => (String(a[key]).toUpperCase() < String(b[key]).toUpperCase() ? -1 : 1);
}

export function close() {
  // eslint-disable-next-line no-restricted-globals
  history?.go(-1);
}
export function goto(...params) {
  window.location = params.join('/');
}
export function sgoto(...params) {
  const href = params.join('/');
  window.history.pushState('ok', 'ok', href);
}
export function clickToCopy(node, passedInValue) {
  function selectAndCopy(text) {
    let tmpEl = document.createElement('textarea');
    tmpEl.innerText = text;
    tmpEl.focus();
    tmpEl.select();
    document.execCommand('copy');
    tmpEl = null;
  }

  async function handler(ev) {
    console.log('copy clicked');
    const text = ev.target.value || ev.target.innerText || ev.target.innerHTML;
    // select and copy to cb
    selectAndCopy(text);
    // or just copy directly to cb
    await navigator?.clipboard?.writeText(text);
  }

  node.onclick = passedInValue
    ? () => {
      handler({ target: { value: passedInValue } });
    }
    : handler;

  return {
    update(updatedNode) {
      if (updatedNode) {
        node.onclick = () => handler({ target: updatedNode });
      }
    },
    destroy() {
      node.removeEventListener('click', handler);
    },
  };
}

export function credsToUsd(creds = 0) {
  return creds / 100;
}

export function formatMoney(amt, minimumFractionDigits = 0) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits,
  }).format(amt);
}
export function formatNumber(amt) {
  return new Intl.NumberFormat().format(amt);
}

const baseUrl = '/webforma-services';
export function getUrl(path, base = baseUrl) {
  // TODO: use the URL constructor here
  return [base, path].join('/');
}

// Buggy implementation
export function reportModal(store) {
  onMount(() => {
    store.update((s) => {
      s.isModal = true;
      return s;
    });
  });
  onDestroy(() => {
    store.update((s) => {
      s.isModal = false;
      return s;
    });
  });
}

// TODO: Works poorly - do without state?
export function navSupport(store) {
  return (event) => {
    const app = get(store);
    if (event.key === 'Escape' && app?.isModal) {
      window.history.go(-1);
    }
  };
}
export function exitIfEscape(location) {
  return (event) => {
    if (event.key === 'Escape') {
      goto(location);
    }
  };
}

export function getSiteTitle(app, routes) {
  const title = [
    get(app)?.titleBase,
    routes.find((r) => r.path === window.location.pathname)?.siteTitle,
  ]
    .filter((a) => a)
    .join(' | ');

  return title;
}
